// /* Text-size styles */
// --heading-1: 35px;
// --heading-2: 28px;
// --heading-3: 21px;
// --heading-4: 18px;
// --heading-5: 14px;
// --heading-6: 14px;
// --u-i--text: 14px;
// --body: 16px;
// --u-i--text - -small: 12px;
// --body-- -code: 14px;

// /* Effect styles */
// --drop--shadow -default -l-v 1:  4px 0px 2px rgba(0, 0, 0, 0.15);
// --drop--shadow -primary -l-v 1:  4px 0px 2px rgba(167, 16, 42, 0.25);
// --drop--shadow -secondary -l-v 1:  4px 0px 2px rgba(203, 50, 12, 0.25);
// --drop--shadow -success -l-v 1:  4px 0px 2px rgba(27, 143, 59, 0.25);
// --drop--shadow -danger -l-v 1:  4px 0px 2px rgba(171, 23, 14, 0.25);
// --drop--shadow -warning -l-v 1:  4px 0px 2px rgba(185, 133, 0, 0.25);
// --drop--shadow -info -l-v 1:  4px 0px 2px rgba(28, 155, 163, 0.25);
// --drop--shadow -blue -l-v 1:  4px 0px 2px rgba(28, 95, 157, 0.25);
// --drop--shadow -default -l-v 4:  16px 0px 8px rgba(0, 0, 0, 0.15);
// --drop--shadow -primary -l-v 4:  16px 0px 8px rgba(167, 16, 42, 0.25);
// --drop--shadow -secondary -l-v 4:  16px 0px 8px rgba(203, 50, 12, 0.25);
// --drop--shadow -success -l-v 4:  16px 0px 8px rgba(27, 143, 59, 0.25);
// --drop--shadow -danger -l-v 4:  16px 0px 8px rgba(171, 23, 14, 0.25);
// --drop--shadow -warning -l-v 4:  16px 0px 8px rgba(185, 133, 0, 0.25);
// --drop--shadow -info -l-v 4:  16px 0px 8px rgba(28, 155, 163, 0.25);
// --drop--shadow -blue -l-v 4:  16px 0px 8px rgba(28, 95, 157, 0.25);

const colorName: { [key: string]: string } = {
  primaryLight: '#F4F7FF',
  primary: '#D1DFFF',
  primaryDark: '#154DCC',
  secondaryLight: '#F7FBFF',
  secondary: '#DDF0FE',
  secondaryDark: '#55B6FA',
  textColor: '#E5E5E5',
  textSecondary: '#9295AA',
  textDisabled: '#2B2F45',
  white: '#FFFFFF',
  lightBackground: '#EEF1F5',
  darkBackgroundShaded: '#3B3435',
  darkBackground: '#271D1F',
  successLight: '#F5FDF7',
  success: '#30CD60',
  successDark: '#26A44D',
  dangerLight: '#FDF6F6',
  danger: '#DA4343',
  dangerDark: '#AE3636',
  warningLight: '#FFFBF5',
  warning: '#FFA940',
  warningDark: '#CC8733',
  infoLight: '#E8F4FF',
  info: '#1990FF',
  infoDark: '#0F5699',
  blueLight: '#E3F1FD',
  blue: '#1F82DE',
  blueDark: '#1C5F9D',
  borderColor: 'rgba(255, 255, 255, 0.1)',
  borderColorDarkBg: '#676767',

  defaultLight: '#EEF1F5',
  default: '#AAAAAA',
  defaultDark: '#7E7E7E',
  background: '#0E1124',
  divider: '#3C406C',
  disable: '#2B2F45',
  border: '#E8E8E8',
  placeholder: '#A7ABC3',
  button: '#C54B4D',
  buttonText: '#E6E6E6',
  icon: '#FAFAFA',
  borderSelected: '#1990FF',

  // primary: '#647BCE',
  // primaryLight: '#E2E9FF',
  // primaryHalfLight: '#B4C4FD',
  // primaryHalfDark: '#4F64B4',
  // primaryDark: '#485586',

  // secondary: '#545767',
  // accent: '#F17F67',

  // textColor: '#333333',
  // textColorWhite: 'white',
  // textSecondary: '#828282',

  // lightBackground: '#ECEDF1',
  // darkBackground: '#434552',

  // borderColor: '#d3d4da',
  // textMuted: '#cccccc',

  // successLight: '#C9E8CE',
  // success: '#78C584',
  // successDark: '#40944D',
  // warningLight: '#F9EFD4',
  // warning: '#EAC35E',
  // warningDark: '#C19319',
  // dangerLight: '#FAD7D7',
  // danger: '#ED6868',
  // dangerDark: '#DA3535',
  // infoLight: '#CEEFF6',
  // info: '#85D7E9',
  // infoDark: '#229FBA',
  // link: '#8BA3F9',

  // muted: '#828282',
  // disabled: '#cccccc',
  // light: '#ffffff',
};

export default colorName;
